import { DesignationDTO } from "./designation.dto";
import { Injectable } from "@nestjs/common";
import { Designation } from "../designation.entity";

@Injectable()
export class DesignationAdapter{

    public convertDtoToEntity(designationDTO: DesignationDTO, isUpdate: boolean = false): Designation{
        const designationEntity = new Designation();
        designationEntity.designationId= designationDTO.designationId
        designationEntity.designation = designationDTO.designation;
        designationEntity.isActive = designationDTO.isActive === undefined ? true : designationDTO.isActive;
        if(isUpdate){
            designationEntity.updatedUser = designationDTO.updatedUser;
        }else{
            designationEntity.isActive = true;
            designationEntity.createdUser = designationDTO.createdUser;
        }
        return designationEntity;
    }

    public convertEntityToDto(designationObj: Designation): DesignationDTO{
        const designationDTO = new DesignationDTO;
        designationDTO.designationId= designationObj.designationId
        designationDTO.designation = designationObj.designation;
        designationDTO.isActive = designationObj.isActive;
        designationDTO.createdAt = designationObj.createdAt;
        designationDTO.updatedAt = designationObj.updatedAt;
        designationDTO.updatedUser = designationObj.updatedUser;
        designationDTO.createdUser = designationObj.createdUser;
        designationDTO.versionFlag = designationObj.versionFlag;
        return designationDTO;

    }
}